export const GET_AGENTS = 'GET_AGENTS';

